import React, { useState, useEffect, useRef } from "react";
import phonecodes from "../../api/phonecode";
import { get_flagcdn_url } from "../../api/utils";

const Countrycodepicker = ({ defaultCode = "+91", onChange }) => {
  const [selectedCode, setSelectedCode] = useState(defaultCode);
  const [search, setSearch] = useState("");
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  const filteredCodes = phonecodes.filter((country) =>
    country.name.toLowerCase().includes(search.toLowerCase())
  );

  const handleSelectCode = (phonecode) => {
    setSelectedCode(phonecode);
    onChange(phonecode);
    setIsOpen(false);
    setSearch("");
  };

  const handleKeyDownInput = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      if (filteredCodes.length > 0) {
        const phonecode = filteredCodes[0].phonecode;
        setSelectedCode(phonecode);
        onChange(phonecode);
        setIsOpen(false);
        setSearch("");
      }
    }
  };

  const handleClickOutside = (event) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      setIsOpen(false);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <div className="relative">
      <div
        className="w-[72px] h-[54px] flex items-center justify-center border cursor-pointer text-sm bg-[#2C2D36] border-[#444444] rounded-3xl"
        onClick={() => setIsOpen(!isOpen)}
      >
        <span className="mr-2">{selectedCode}</span>
        <span>&#9662;</span>
      </div>

      {isOpen && (
        <div
          ref={dropdownRef}
          className="absolute mt-1 w-[200px] bg-[#2C2D36] border-[#444444] rounded-xl shadow-lg border max-h-60 overflow-y-auto z-10 hide-scrollbar"
        >
          <input
            autoFocus
            type="text"
            placeholder="Search"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            onKeyDown={handleKeyDownInput}
            className="w-full p-2 border-b bg-[#2C2D36] border-[#444444] text-sm sticky top-0 focus:outline-none"
          />
          <ul className="max-h-56">
            {filteredCodes?.length ? (
              filteredCodes.map((country) => (
                <li
                  key={country.id}
                  className="p-2 hover:bg-[#32333a] cursor-pointer text-xs"
                  onClick={() => handleSelectCode(country.phonecode)}
                >
                  <div className="flex items-center gap-3">
                    <div className="w-[20px] flex-shrink-0">
                      <img
                        alt={country.iso}
                        loading="lazy"
                        src={get_flagcdn_url(country.iso)}
                        className="w-[20px]"
                      />
                    </div>
                    <div>
                      {country.name} {country.phonecode}
                    </div>
                  </div>
                </li>
              ))
            ) : (
              <li className="p-2 hover:bg-[#32333a] cursor-pointer text-xs">
                No country found!
              </li>
            )}
          </ul>
        </div>
      )}
    </div>
  );
};

export default Countrycodepicker;
